import { UIVersion } from '../../types'

const STUDENT_REDESSIGN_ROUTES = new Set(['/', '/dashboard', '/rutina'])

export const isRedesignPreviewPath = (pathname: string) =>
  pathname === '/redesign' || pathname.startsWith('/redesign/')

export const shouldUseStudentRedesign = ({
  pathname,
  uiVersion,
}: {
  pathname: string
  uiVersion?: UIVersion
}) =>
  isRedesignPreviewPath(pathname) ||
  (uiVersion === 'redesign' && STUDENT_REDESSIGN_ROUTES.has(pathname))
